<template>
    <div v-if="filterText" class="mt-6 mb-3 text-center">
        <div class="subtitle-2">
            <v-img src="img/not-found.jpg" :class="{'rounded-circle': isDark}" class="w-50 text-center mx-auto" :gradient="isDark ? 'to top right, rgb(148, 156, 162, .1), rgb(148, 156, 162, .3)' : ''" max-width="200" />
            <div class="my-6">{{ message }}</div>
        </div>
    </div>
</template>
<script>
import MixinDark from "@/mixins/database/MixinDark";

export default {
    name: "rules-no-matching-search-result",
    mixins: [MixinDark],
    props: {
        filterText: {
            type: String,
            required: true,
        }
    },
    computed: {
        message() {
            return this.$gettextInterpolate(this.$gettext('No matching rules found for your search: %{ rule }'), {
                rule: this.filterText
            })
        },
    }
}
</script>
<style scoped type="text/scss">
.w-50{
    width: 50%;
}
</style>
